import { Link } from 'react-router'
import { Grid } from 'semantic-ui-react'
import moment from 'moment'
import { Button } from '@120wateraudit/envirio-components/dist/components/Button'
import styles from './SubMenu.module.scss'
import { Icon } from 'semantic-ui-react'
import React from 'react'
import ShareModal from '../ShareModal/ShareModal'
import { Responsive } from '../Responsive/Responsive'

interface SubMenuProps {
  accountId?: number
  accountName?: string
  title: string
}

export class SubMenu extends React.Component<SubMenuProps, SubMenuState> {
  constructor(props: SubMenuProps) {
    super(props)

    this.state = {
      shareIsOpen: false,
      valueToCopy: '',
      copied: false
    }
  }

  render() {
    const { accountId, title, accountName } = this.props
    const { shareIsOpen } = this.state

    return (
      <Grid
        verticalAlign="bottom"
        className={styles.detailsSubMenu + ' buildingBlock'}
      >
        <Grid.Column mobile={8} computer={10}>
          {accountId && (
            <Link to="/">
              <span className={styles.backLink}>Back To Dashboard</span>
            </Link>
          )}
          <h1 className={styles.facilityTitle}>{title}</h1>
        </Grid.Column>
        <Grid.Column mobile={8} computer={6}>
          <div className={styles.shareContainer}>
            <Responsive platform="desktop">
              <div className={styles.date}>
                {moment().format('dddd, MMMM D, YYYY')}
              </div>
            </Responsive>
            <Button
              size="med"
              variant="default"
              className={styles.shareButton + ' ignore-react-onclickoutside'}
              onClick={this.toggleShareModal}
            >
              <span>Share</span> <Icon name="share alternate" />
            </Button>
          </div>
        </Grid.Column>
        {shareIsOpen && (
          <ShareModal
            accountName={accountName}
            shareIsOpen={this.state.shareIsOpen}
            onToggleModal={this.toggleShareModal}
          />
        )}
      </Grid>
    )
  }

  private toggleShareModal = () => {
    this.setState({
      shareIsOpen: !this.state.shareIsOpen,
      copied: false
    })
  }
}

interface SubMenuState {
  shareIsOpen: boolean
  copied: boolean
  valueToCopy: string
}
